import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';
export function SkpCTA() {
  return <section className="bg-white border-t border-line py-20 lg:py-28" data-id="element-2378" data-mp="1dpsqb2b9t3na">
      <motion.div {...fadeUp} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2379" data-mp="1ipnlhi22wfe5">
        <h2 className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight mb-6" data-id="element-2380" data-mp="1njhzq5yx025u">
          Build with SyNeural
        </h2>
        <p className="text-xl text-ink-muted leading-relaxed mb-10" data-id="element-2381" data-mp="1wid5jgy1ra8m">
          Explore a research knowledge platform, discuss an NCJI integration, or
          design a governed semantic workflow for your institution.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-2382" data-mp="26frllfg25x0e">
          <a href="/contact" className="inline-flex items-center justify-center gap-2 bg-navy text-white hover:bg-navy-light font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-2383" data-mp="73ylvb1vydjz">
            Contact Us
            <ArrowRight size={18} aria-hidden="true" data-id="element-2384" data-mp="2h3t061v7dfo6" />
          </a>
          <a href="/partnerships" className="inline-flex items-center justify-center border border-line text-navy hover:bg-surface-muted font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-2385" data-mp="2ca85aiowp1t7">
            Explore a Partnership
          </a>
        </div>
      </motion.div>
    </section>;
}